// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2793":"c2fcb221","3282":"3e7534e9","5779":"089988c9","7954":"4bae75f6"}[chunkId] + ".chunk.css";
};